import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const confirmPasswordValidator: ValidatorFn = (group: UntypedFormGroup): ValidationErrors | null => {
  const password = group.get('password').value;
  const confirmPassword = group.get('confirmPassword').value;

  /*
   * We actually set the error to confirmPassword so it can be displayed under the repeat password
   * */
  if (confirmPassword && password !== confirmPassword) {
    group.get('confirmPassword').setErrors({ passwordsNotTheSame: true });
  }
  return null;
};
